import Vue from "vue";
import iView from "view-design";
import VueI18n from "vue-i18n";
import cookie from "../../static/js/cookie";
import zhLocale from "./lang/zh.js";
import enLocale from "./lang/en.js";
// import zh from "view-design/dist/locale/zh-CN";
// import en from "view-design/dist/locale/en-US";
// import zh from "./lang/zh-CN.js";
// import en from "./lang/en-US.js";

Vue.use(VueI18n);
Vue.use(iView);
// Vue.locale = () => {};

// Ready translated locale messages
let locale = cookie.get("language") || "zh";
console.log(`结果${locale}`);

const messages = {
  // zh: Object.assign(zhLocale, zh),
  // en: Object.assign(enLocale, en),

  zh: zhLocale,
  en: enLocale
};

console.log(messages);

//判断浏览器语言
export default new VueI18n({
  locale, // set locale
  messages // set locale messages
});



// WEBPACK FOOTER //
// ./src/i18n/i18n.js